import React from 'react'
import Reflux from 'reflux'
import _ from 'lodash'

import SimpleSelect from '~/modules/_core/simpleSelect.jsx'

import CategoriesStore from '~/stores/categories.js'


export default class ShoppingListSelectCategory extends Reflux.Component {
	constructor(props) {
		super(props)

		this.store = CategoriesStore
	}

	render() {
		const categoryList = [{
			category: 'All',
			categoryID: 0,
			recipesInCategoryCount: _.sum(_.map(this.state.categories, 'recipesInCategoryCount'))
		}]

		_.forEach(
			this.state.categories,
			category => categoryList.push(category)
		)
		categoryList.push(_.cloneDeep(this.state.categories))

		const passOptions = _.filter(categoryList, x => x.recipesInCategoryCount > 0)

		return (
			<SimpleSelect
				onChange={this.props.onChange}
				name="categoryID"
				value={this.props.value}
				options={passOptions}
				itemKeyValue="categoryID"
				itemKeyLabel="category"
			/>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/shoppingList/selectCategory.jsx